import { useState, useCallback } from "react";

const STORAGE_KEY = "sprakbild_learned";

export const useProgress = () => {
  const [learnedWords, setLearnedWords] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  const markAsLearned = useCallback((wordId) => {
    setLearnedWords((prev) => {
      const updated = [...new Set([...prev, wordId])];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      return updated;
    });
  }, []);

  const isLearned = useCallback((wordId) => learnedWords.includes(wordId), [learnedWords]);

  const resetProgress = useCallback(() => {
    setLearnedWords([]);
    localStorage.removeItem(STORAGE_KEY);
  }, []);

  return { learnedWords, markAsLearned, isLearned, resetProgress, totalLearned: learnedWords.length };
};
